import { Button, Signage } from '@kcd/design-system';

import { useGoHome } from '~/hooks/url';

import AlertIcon from '~/assets/icons/ic__system__alert__filled.svg';

export default function ErrorPage({
  title = '일시적인 오류가 발생했습니다.',
  description,
  resetText = '캐시노트마켓 홈으로 이동',
  onResetClick,
}: {
  title?: string;
  description?: string;
  resetText?: string;
  onResetClick?: React.MouseEventHandler<HTMLButtonElement>;
}) {
  const goHome = useGoHome('replace');

  return (
    <Signage
      verticalCenter
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
      marginTop={0 as any}
      image={() => <AlertIcon />}
      title={title}
      description={description}
      action={
        <Button size="sm" variant="outline" onClick={onResetClick || goHome}>
          {resetText}
        </Button>
      }
    />
  );
}
